import { DIALYSIS_ATTENDANCE_STATUS } from './reading';
import { NOTIFICATION_ACTION } from '@/features/notifications/constants/notification';

export const FLUID_NOTIFICATION = Object.freeze({
  READING: 'FLUID_READING_REMINDER',
  FOLLOWUP: 'FLUID_READING_FOLLOWUP',
  ATTENDANCE: 'DIALYSIS_ATTENDANCE_CONFIRMATION',
  OVERDUE: 'DIALYSIS_OVERDUE',
  DRY_WEIGHT: 'DRY_WEIGHT_UPDATED',
  ALERT: 'FLUID_IDWG_ALERT',
  NOTICE: 'FLUID_IDWG_NOTICE',
});

export const FLUID_PROMPT_KIND = Object.freeze({
  READING: 'reading',
  NOTIFICATION: 'notification',
});

const ATTENDANCE_RESPONSE = Object.freeze({
  field: 'status',
  labels: {
    [DIALYSIS_ATTENDANCE_STATUS.ATTENDED]: 'notifications.answers.attended',
    [DIALYSIS_ATTENDANCE_STATUS.NO]: 'notifications.answers.notAttended',
  },
  datesField: 'dates',
  noteField: 'note',
  outcomes: { [NOTIFICATION_ACTION.DISMISSED]: 'notifications.outcomes.alertClosed' },
});

const READING_RESPONSE = Object.freeze({
  outcomes: { [NOTIFICATION_ACTION.FULFILLED]: 'notifications.outcomes.readingSaved' },
});

export const FLUID_NOTIFICATION_PRESENTATION = Object.freeze({
  [FLUID_NOTIFICATION.READING]: {
    tone: 'info',
    icon: 'drop',
    response: READING_RESPONSE,
  },
  [FLUID_NOTIFICATION.FOLLOWUP]: {
    tone: 'teal',
    icon: 'clock',
    response: READING_RESPONSE,
  },
  [FLUID_NOTIFICATION.ATTENDANCE]: {
    tone: 'violet',
    icon: 'calendar',
    response: ATTENDANCE_RESPONSE,
  },
  [FLUID_NOTIFICATION.OVERDUE]: {
    tone: 'destructive',
    icon: 'alert',
    response: ATTENDANCE_RESPONSE,
  },
  [FLUID_NOTIFICATION.DRY_WEIGHT]: {
    tone: 'info',
    icon: 'scale',
    response: {
      outcomes: { [NOTIFICATION_ACTION.FULFILLED]: 'notifications.outcomes.dryWeightViewed' },
    },
  },
  [FLUID_NOTIFICATION.ALERT]: {
    tone: 'destructive',
    icon: 'scale',
    response: {
      outcomes: { [NOTIFICATION_ACTION.DISMISSED]: 'notifications.outcomes.alertClosed' },
    },
  },
  [FLUID_NOTIFICATION.NOTICE]: { tone: 'warning', icon: 'scale' },
});
